/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoTerapiaDTO
 */
export interface AssistitoTerapiaDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaDTO
     */
    richiedente?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaDTO
     */
    patologiaMotivante?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssistitoTerapiaDTO
     */
    dataInizio?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaDTO
     */
    tipologiaMedicinale?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaDTO
     */
    posologia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoTerapiaDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoTerapiaDTO interface.
 */
export function instanceOfAssistitoTerapiaDTO(value: object): value is AssistitoTerapiaDTO {
    return true;
}

export function AssistitoTerapiaDTOFromJSON(json: any): AssistitoTerapiaDTO {
    return AssistitoTerapiaDTOFromJSONTyped(json, false);
}

export function AssistitoTerapiaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoTerapiaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'richiedente': json['richiedente'] == null ? undefined : json['richiedente'],
        'patologiaMotivante': json['patologiaMotivante'] == null ? undefined : json['patologiaMotivante'],
        'dataInizio': json['dataInizio'] == null ? undefined : (new Date(json['dataInizio'])),
        'tipologiaMedicinale': json['tipologiaMedicinale'] == null ? undefined : json['tipologiaMedicinale'],
        'posologia': json['posologia'] == null ? undefined : json['posologia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoTerapiaDTOToJSON(value?: AssistitoTerapiaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'nome': value['nome'],
        'richiedente': value['richiedente'],
        'patologiaMotivante': value['patologiaMotivante'],
        'dataInizio': value['dataInizio'] == null ? undefined : ((value['dataInizio'] as any).toISOString()),
        'tipologiaMedicinale': value['tipologiaMedicinale'],
        'posologia': value['posologia'],
        'note': value['note'],
    };
}

